import { LucideIcon } from 'lucide-react'; // Optional: gives you better typings

type UIIconProps = {
    icon: LucideIcon; // or: React.ComponentType<React.SVGProps<SVGSVGElement>>
    color?: string;
};

export default function UIIcon({ icon : Icon, color } : UIIconProps) {
    return (
        <Icon color={color} style={{ verticalAlign: 'middle', marginBottom: '4px' }} />
    );
};
